import api from './api';

export type McpConnectionStatus = 'approved' | 'revoked';
export type AiApp = 'chatgpt' | 'claude' | 'claude_code' | 'other';

export interface McpConnection {
  id: string;
  client_id: string;
  client_name: string | null;
  app: AiApp;
  status: McpConnectionStatus;
  approved_at: string | null;
  revoked_at: string | null;
  last_used_at: string | null;
}

/**
 * External-AI (remote MCP) connections. Created by the OAuth consent flow —
 * this surface lists them and revokes per app (revoke also kills the app's
 * tokens; reconnecting happens from the AI app, which re-runs OAuth).
 */
export const mcpConnectionsService = {
  list: async (): Promise<{ connections: McpConnection[] }> => {
    const { data } = await api.get('/api/mcp-connections');
    return data;
  },
  revoke: async (id: string): Promise<{ connection: McpConnection | null }> => {
    const { data } = await api.post(`/api/mcp-connections/${id}/revoke`);
    return data;
  },
};
